<template lang="pug">
.detail-section__readmore
	.detail-section__content(ref="content" :class="{'detail-section__content--clamped': collapsed && overflowing}" v-html="content")
	button.detail-section__readmore-btn(v-if="overflowing" type="button" @click="collapsed = !collapsed")
		| {{ collapsed ? moreText : lessText }}
</template>

<script>
	export default {
		props: {
			content: {
				type: String,
				default: ''
			},
			moreText: {
				type: String,
				default: 'Show more'
			},
			lessText: {
				type: String,
				default: 'Show less'
			},
			lines: {
				type: Number,
				default: 8
			}
		},

		data() {
			return {
				collapsed: true,
				overflowing: false
			};
		},

		mounted() {
			this.$nextTick(this.checkOverflow);
			window.addEventListener('resize', this.checkOverflow);
		},

		beforeUnmount() {
			window.removeEventListener('resize', this.checkOverflow);
		},

		watch: {
			content() {
				this.$nextTick(this.checkOverflow);
			}
		},

		methods: {
			checkOverflow() {
				const el = this.$refs.content;
				if (!el) {
					this.overflowing = false;
					return;
				}
				const style = getComputedStyle(el);
				let lineHeight = parseFloat(style.lineHeight);
				if (isNaN(lineHeight)) {
					lineHeight = parseFloat(style.fontSize) * 1.4;
				}
				// scrollHeight — полная высота контента даже при клампе, сравниваем с
				// высотой N строк; кнопку показываем только если текст длиннее
				this.overflowing = el.scrollHeight > lineHeight * this.lines + 1;
			}
		}
	};
</script>
